export const GreenCheckIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1387_9375)">
        <path
          d="M10.2507 20.1668C15.5894 20.1668 19.9173 15.8389 19.9173 10.5002C19.9173 5.16141 15.5894 0.833496 10.2507 0.833496C4.9119 0.833496 0.583984 5.16141 0.583984 10.5002C0.583984 15.8389 4.9119 20.1668 10.2507 20.1668Z"
          fill="#5EDD60"
        />
        <path
          d="M8.33762 14.5231L6.07095 12.3091C6.02193 12.2615 5.98295 12.2045 5.95634 12.1415C5.92973 12.0785 5.91602 12.0108 5.91602 11.9424C5.91602 11.8741 5.92973 11.8064 5.95634 11.7434C5.98295 11.6804 6.02193 11.6234 6.07095 11.5758L6.82262 10.8424C6.92342 10.7448 7.05827 10.6902 7.19862 10.6902C7.33897 10.6902 7.47382 10.7448 7.57462 10.8424L8.92395 12.1614L12.7083 6.40811C12.7864 6.29202 12.9065 6.21083 13.0434 6.18172C13.1802 6.15261 13.323 6.17785 13.4416 6.25211L14.3363 6.81411C14.3947 6.85004 14.4453 6.89734 14.4852 6.95321C14.525 7.00907 14.5532 7.07236 14.568 7.13933C14.5829 7.20629 14.5842 7.27556 14.5718 7.34303C14.5595 7.4105 14.5337 7.4748 14.496 7.53211L10.015 14.3468C9.92516 14.4802 9.80722 14.5922 9.66943 14.6751C9.53164 14.758 9.37736 14.8097 9.21745 14.8265C9.05754 14.8433 8.89588 14.8248 8.74387 14.7724C8.59186 14.72 8.45319 14.6349 8.33762 14.5231Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1387_9375">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.25 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
